import React, { useEffect, useState } from 'react'
import invertColor from '../../../../../util/invertColor'
import Modal from '../../../../../../../../../common/components/Modal/Modal'
import TextArea from '../../../../../../../../../common/components/Form/TextArea/TextArea'
import { CARD_BACKGROUND_COLOR } from '../../utils/constants.js'
import { getClassSizeCardText } from '../../utils/utils.js'

import './EditorCardTextModal.scss'

const MAX_TEXT_LENGTH = 70

const EditorCardTextModal = ({ text = '', bgColor = CARD_BACKGROUND_COLOR[0], onClose, onSubmit, t }) => {
    const [_text, _setText] = useState(text)
    const [selectedBackground, setSelectedBackground] = useState(bgColor)
    const [isCanSave, setIsCanSave] = useState(false)

    useEffect(() => {
        if (_text.length > 0 && _text.length <= MAX_TEXT_LENGTH) {
            setIsCanSave(true)
        } else {
            setIsCanSave(false)
        }
    }, [_text])

    const onSave = () => {
        if (isCanSave) {
            onSubmit({
                isText: true,
                text: _text,
                bgColor: selectedBackground,
                color: invertColor(selectedBackground, true),
            })
        }
    }

    const mainCardStyles = {
        backgroundColor: selectedBackground,
        color: invertColor(selectedBackground, true),
    }

    return (
        <Modal closeOnOverlayClick={false} closeOnEsc={false}>
            <div className="editor-card-text">
                <h2 className="editor-card-text__header">{t('Text on card')}</h2>
                <div className="editor-card-text__body">
                    <div className="editor-card-text__body-content">
                        <div className="editor-card-text__body-content-block">
                            <div className="editor-card-text__body-title-block">
                                <h3 className="editor-card-text__body-title">{t('Text on card')}</h3>
                                <h3
                                    className={`editor-card-text__body-title-count ${
                                        _text.length >= MAX_TEXT_LENGTH ? 'error' : ''
                                    }`}
                                >
                                    {_text.length}/{MAX_TEXT_LENGTH}
                                </h3>
                            </div>
                            <TextArea
                                value={_text}
                                onUpdate={value => _setText(value)}
                                rows={3}
                                maxLength={MAX_TEXT_LENGTH}
                            />
                        </div>

                        <div className="editor-card-text__body-content-block">
                            <h3 className="editor-card-text__body-title">{t('Card color')}</h3>
                            <div className="editor-card-text__body-content-color-picker">
                                {CARD_BACKGROUND_COLOR.map(color => (
                                    <div
                                        key={color}
                                        className={`editor-card-text__body-content-color-picker-item ${
                                            selectedBackground === color ? 'is-selected' : ''
                                        }`}
                                        style={{ backgroundColor: color, color: invertColor(color, true) }}
                                        onClick={() => setSelectedBackground(color)}
                                    />
                                ))}
                            </div>
                        </div>
                    </div>
                    <div className="editor-card-text__body-preview">
                        <h3 className="editor-card-text__body-title">{t('Preview')}</h3>
                        <div className="editor-card-text__body-preview-block" style={mainCardStyles}>
                            <p className={`editor-card-text__body-preview-text ${getClassSizeCardText(_text.length)}`}>
                                {_text}
                            </p>
                        </div>
                    </div>
                </div>
                <div className="editor-card-text__buttons">
                    <button className="button" data-variant="secondary" data-size="lg" onClick={() => onClose()}>
                        {t('Cancel')}
                    </button>
                    <button
                        className="button"
                        data-variant="primary"
                        data-size="lg"
                        disabled={!isCanSave}
                        onClick={() => onSave()}
                    >
                        {t('Save')}
                    </button>
                </div>
            </div>
        </Modal>
    )
}

export default EditorCardTextModal
